import BaseModel from "../base_model.js";

import UploadPdfUseCase from "../../use_cases/assets/pdfs/upload_pdf_use_case.js";

class RawProjectDocumentModel extends BaseModel {

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
      },
      {
        name: "showInConfirmationPage",
        displayName: this.fieldDisplayName("showInConfirmationPage"),
        type: "boolean"
      },
      {
        name: "attachToEmail",
        displayName: this.fieldDisplayName("attachToEmail"),
        type: "boolean"
      },
      {
        name: "pdf",
        type: "file",
        weight: 12,
        allowDelete: false,
        foreignKey: "pdfId",
        allowSelfLoad: false,
        allowAutoDeleteOnError: true,
        uploader: (file) => {
          return UploadPdfUseCase.execute(file).then(result => {
            return result.data.pdf;
          })
        }
      },
    ]
  }

  i18nScope() {
    return "model.projects.document";
  }

}
const ProjectDocumentModel = new RawProjectDocumentModel();

export { RawProjectDocumentModel, ProjectDocumentModel }
